import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'serviceFilter'
})
export class ServiceFilterPipe implements PipeTransform {
 
  transform(entities: any[], searchFilter: string, searchProofed: boolean, searchStatus: boolean): any[] {
 
    console.log(searchStatus, searchProofed);

    if (searchFilter === undefined || searchFilter === "" || searchFilter.length < 2) {
      if (searchProofed === null && searchStatus === null) {
        return entities;
      } 
    }

    var results = this.filterByName(entities, searchFilter);

    results = this.filterByProofed(results, searchProofed);
    results = this.filterByStatus(results, searchStatus);

     return results;
  
 
   }
   

   private filterByName(entities: any[], searchTerm: string) {
     
 
    if (searchTerm === undefined) {
      return entities;
    }

    searchTerm = searchTerm.toLowerCase();

    var results = entities.filter((entity) => {
      var matches = entity.AvailableSearchTerms.filter((s) => {
        if (s == null) return null;
        return (s.toLowerCase().indexOf(searchTerm) > -1)
      });

      return matches.length > 0;
    });

    return results;
   }

   private filterByProofed(entities: any[], searchProofed: boolean) {
     
    if (searchProofed === true) {
      var results = entities.filter((entity) => {
         return (entity.IsProofed === true);
      });
      
      return results;
    } 
    else if (searchProofed == false) {
      var results = entities.filter((entity) => {
         return (entity.IsProofed === false);
      });

      return results;
    } 
    else {
      return entities;
    }

 }

 private filterByStatus(entities: any[], searchStatus: boolean) {
     
  if (searchStatus === true) {
    var results = entities.filter((entity) => {
       return (entity.IsActive === true);
    });
    
    return results;
  } 
  else if (searchStatus == false) {
    var results = entities.filter((entity) => {
       return (entity.IsActive === false);
    });

    return results;
  } 
  else {
    return entities;
  }

}

}
